import { render } from "./PermissionGuard.vue?vue&type=template&id=98027c3a"
import script from "./PermissionGuard.vue?vue&type=script&lang=js"
export * from "./PermissionGuard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__